// extracted by mini-css-extract-plugin
export default {"main":"RegisterPage_main__2OZ7C","head":"RegisterPage_head__lGXwv","form":"RegisterPage_form__keSOP","heading":"RegisterPage_heading__w8hcv"};